import { normalize as n, schema } from "normalizr";

const normalize = (data, schema, defaultEntitities) => {
  const res = n(data, schema);
  return {
    result: res.result,
    entities: { ...defaultEntitities, ...res.entities }
  };
};

export { normalize, schema };
